import { useTranslation } from 'react-i18next'

import { Icons } from 'helpers/icons'

interface PostScheduleProps {
    price: number | null
    removePrice: any
    scheduleDate: Date | null
    removeSchedule: any
}

export const PostSchedule = ({
    price,
    removePrice,
    scheduleDate,
    removeSchedule
}: PostScheduleProps) => {
    const { t } = useTranslation()

    const formattedPrice = price !== null ? price.toFixed(2) : "0.00"; // Format price to 2 decimals

    return (
        <div
            style={{
                justifyContent: scheduleDate ? 'space-between' : 'flex-end'
            }}
            className='newpost__schedule'
        >
            {scheduleDate && (
                <div className='newpost__schedule__time'>
                    <p>
                        {t('sheduledFor')}{' '}
                        <span>
                            {new Date(scheduleDate).toLocaleDateString(
                                'en-US',
                                {
                                    month: 'long',
                                    day: 'numeric',
                                    hour: 'numeric',
                                    minute: 'numeric'
                                }
                            )}
                        </span>
                    </p>
                    <img
                        src={Icons.close}
                        alt={t('removeDate')}
                        onClick={removeSchedule}
                    />
                </div>
            )}
            {price !== null && (
                <div className='newpost__schedule__price'>
                    <p>${formattedPrice}</p> {/* Display formatted price */}
                    <img
                        src={Icons.close}
                        alt={t('removePrice')}
                        onClick={removePrice}
                    />
                </div>
            )}
        </div>
    )
}
